export const stats = [
  { value: 2833, suffix: '+', label: 'STUDENTS WORLDWIDE' },
  { value: 4, suffix: '', label: 'PREMIUM COURSES' },
  { value: 11, suffix: '+', label: 'YEARS EXPERIENCE' },
  { value: 2, suffix: '', label: 'SPIRITUAL PILLARS' },
];

export const guides = [
  {
    id: 1,
    name: 'Dr. Nawwaf Alshibli',
    title: 'Quantum Consciousness Master',
    image: 'https://horizons-cdn.hostinger.com/59acda11-1fe7-45ae-84f5-bfd9fe57f3f5/b65dd6f2bc44f8dcde6ffe94cedb6e38.png',
    description: 'With over 20 years of experience in consciousness research and quantum healing, Dr. Alshibli has guided thousands toward awakening.',
  },
];

export const pillars = [
  {
    id: 1,
    icon: 'Sparkles',
    title: 'Spiritual Development',
    description: 'Awaken your divine essence and cultivate deep spiritual wisdom through ancient and modern practices.',
  },
  {
    id: 2,
    icon: 'Sun',
    title: 'Consciousness Uplifting',
    description: 'Expand your awareness and transcend ordinary consciousness to access higher states of being.',
  },
  {
    id: 3,
    icon: 'Atom',
    title: 'Quantum Enlightenment',
    description: 'Merge quantum physics with spiritual wisdom to unlock the secrets of reality and transformation.',
  },
  {
    id: 4,
    icon: 'Heart',
    title: 'Energy Healing',
    description: 'Master the art of energy work and become a conduit for healing, balance, and universal light.',
  },
];

export const courses = [
  {
    id: 1,
    title: 'Awakening Your Inner Light',
    description: 'Discover the divine spark within and illuminate your path to spiritual awakening through ancient wisdom and modern practices.',
    image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=600&q=80',
    category: 'Spiritual Development',
    level: 'Beginner',
    instructor: 'Dr. Nawwaf Alshibli',
    duration: '8 Weeks',
    lessons: '24 Lessons',
  },
  {
    id: 2,
    title: 'Sacred Meditation Practices',
    description: 'Master transformative meditation techniques that connect you with universal consciousness and inner peace.',
    image: 'https://images.unsplash.com/photo-1593811167562-9cef47bfc4d7?w=600&q=80',
    category: 'Spiritual Development',
    level: 'All Levels',
    instructor: 'Dr. Nawwaf Alshibli',
    duration: '6 Weeks',
    lessons: '18 Lessons',
  },
  {
    id: 3,
    title: 'Expanding Consciousness',
    description: 'Transcend ordinary awareness and explore higher dimensions of consciousness through guided practices and quantum principles.',
    image: 'https://images.unsplash.com/photo-1518241353330-0f7941c2d9b5?w=600&q=80',
    category: 'Consciousness Uplifting',
    level: 'Intermediate',
    instructor: 'Dr. Nawwaf Alshibli',
    duration: '10 Weeks',
    lessons: '30 Lessons',
  },
  {
    id: 4,
    title: 'Quantum Mind Mastery',
    description: 'Harness the power of quantum mechanics to unlock unlimited potential and reshape your reality from the mind level.',
    image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=600&q=80',
    category: 'Consciousness Uplifting',
    level: 'Advanced',
    instructor: 'Dr. Nawwaf Alshibli',
    duration: '12 Weeks',
    lessons: '36 Lessons',
  },
  {
    id: 5,
    title: 'Quantum Healing Principles',
    description: 'Learn the foundations of quantum healing to restore balance, vitality, and wholeness at the cellular and energetic levels.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&q=80',
    category: 'Quantum Enlightenment',
    level: 'Intermediate',
    instructor: 'Dr. Nawwaf Alshibli',
    duration: '8 Weeks',
    lessons: '24 Lessons',
  },
  {
    id: 6,
    title: 'Dimensional Consciousness',
    description: 'Journey through multiple dimensions of reality and integrate higher consciousness into your daily existence.',
    image: 'https://images.unsplash.com/photo-1462331940025-496dfbfc7564?w=600&q=80',
    category: 'Quantum Enlightenment',
    level: 'Advanced',
    instructor: 'Dr. Nawwaf Alshibli',
    duration: '10 Weeks',
    lessons: '28 Lessons',
  },
  {
    id: 7,
    title: 'Chakra Alignment Mastery',
    description: 'Balance and activate your seven primary chakras for optimal energy flow, health, and spiritual alignment.',
    image: 'https://images.unsplash.com/photo-1600618528240-fb9fc964b853?w=600&q=80',
    category: 'Energy Healing',
    level: 'Beginner',
    instructor: 'Dr. Nawwaf Alshibli',
    duration: '6 Weeks',
    lessons: '21 Lessons',
  },
  {
    id: 8,
    title: 'Universal Energy Flow',
    description: 'Connect with the infinite source of universal energy and become a conduit for healing light and transformation.',
    image: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=600&q=80',
    category: 'Energy Healing',
    level: 'All Levels',
    instructor: 'Dr. Nawwaf Alshibli',
    duration: '8 Weeks',
    lessons: '22 Lessons',
  },
];

export const books = [
  {
    id: 1,
    title: 'The Quantum Soul',
    author: 'Dr. Nawwaf Alshibli',
    description: 'A groundbreaking exploration of the soul through the lens of quantum mechanics.',
    image: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=800&q=80',
    tags: ['Quantum', 'Soul'],
  },
  {
    id: 2,
    title: 'Consciousness Beyond Dimensions',
    author: 'Dr. Nawwaf Alshibli',
    description: 'An illuminating journey through the layers of consciousness and the quantum fields that shape our reality.',
    image: 'https://images.unsplash.com/photo-1589829085413-56de8ae18c73?w=800&q=80',
    tags: ['Consciousness', 'Quantum'],
  },
  {
    id: 3,
    title: 'Awakening the Third Eye',
    author: 'Master Chen',
    description: 'Practical exercises to open your center of intuition and spiritual sight.',
    image: 'https://images.unsplash.com/photo-1532012197267-da84d127e765?w=800&q=80',
    tags: ['Intuition', 'Awakening'],
  },
];

export const apps = [
  {
    id: 1,
    title: 'Ask Dr. Nawwaf',
    platform: 'Web',
    description: 'Your AI-powered spiritual guide. Ask questions about consciousness, energy healing, and quantum spirituality.',
    tags: ['Web App', 'AI'],
    status: 'available',
    link: '#',
  },
  {
    id: 2,
    title: 'Ask Dr. Nawwaf',
    platform: 'Android',
    description: 'Get spiritual guidance on-the-go. Available on Google Play for all Android devices.',
    tags: ['Android', 'AI'],
    status: 'coming_soon',
    link: '#',
  },
  {
    id: 3,
    title: 'Ask Dr. Nawwaf',
    platform: 'iOS',
    description: 'Your pocket spiritual advisor. Download from the App Store for iPhone and iPad.',
    tags: ['iOS', 'AI'],
    status: 'coming_soon',
    link: '#',
  },
];

export const websites = [
  {
    id: 1,
    title: 'Dr. Nawwaf Al-Shibli Bookstore',
    description: 'Discover transformative books on quantum spirituality, consciousness, and healing.',
    url: 'https://www.nawwaf-alshibli.org/',
    domain: 'www.nawwaf-alshibli.org',
  },
  {
    id: 2,
    title: 'Messengers of Love',
    description: 'A human service platform dedicated to compassion, unity, and serving humanity.',
    url: '#',
    domain: 'Coming Soon',
  },
];

export const categories = [
  'All',
  'Spiritual Development',
  'Consciousness Uplifting',
  'Quantum Enlightenment',
  'Energy Healing',
];
